// https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example
export class StructuredDataError extends Error {
	name: string;
	cause: any;

	constructor(...args: any[]) {
		// 'Error' breaks prototype chain here
		super(...args);

		// set name
		this.name = new.target.name;
		Object.setPrototypeOf(this, new.target.prototype);
	}
}

export class StructuredDataAnnualPriceNotFoundError extends StructuredDataError {}
export class StructuredDataAnnualPriceMultipleFoundError extends StructuredDataError {}
export class StructuredDataAnnualPriceNoCurrenciesFoundError extends StructuredDataError {}
export class StructuredDataAnnualPriceNoCurrencyPriceFoundError extends StructuredDataError {}
export class StructuredDataMonthlyPriceNotFoundError extends StructuredDataError {}
export class StructuredDataMonthlyPriceMultipleFoundError extends StructuredDataError {}
export class StructuredDataMonthlyPriceNoCurrenciesFoundError extends StructuredDataError {}
export class StructuredDataMonthlyPriceNoCurrencyPriceFoundError extends StructuredDataError {}
